<a [ngStyle]="{ 'font-size': '12px', 'margin-top': '12px' }" mat-button color="primary" [routerLink]="['/view-payform', params?.dsrPayformId]" queryParamsHandling="merge">
  {{ params?.dsrName }}
</a>
